import { DamagedPalletDTO } from 'interfaces';

export const damagedPalletDTOToDamagedPalletDataMapper = (damagedPallet: DamagedPalletDTO) => ({
   ...damagedPallet,
   palletType: damagedPallet.type,
});
